import styled from 'styled-components';

import { RadioGroup } from '@dreryk/react-components';

export const StyledReservationPreferenceField = styled(RadioGroup)`
   margin-right: auto;
` as typeof RadioGroup;
